export default __webpack_public_path__ + "static/char-t-21-en-ff9b9b8e1ca9b25ed9bac8d28f719cff.png";